import {SvgIconProps} from "@mui/material";
import React, {ReactNode} from "react";
import AbstractIcon from "../AbstractIcon";


class ActiveResourceEvent extends AbstractIcon {

    public renderDraw(props: SvgIconProps): ReactNode {
        return (
            <g>
                <path d="m 4,5 v 5 H 5 V 5 Z"/>
                <path d="M 6,6 V 9 H 7 V 6 Z"/>
                <path d="m 8,3 v 9 H 9 V 3 Z"/>
                <path d="m 10,4 v 7 h 1 V 4 Z"/>
                <path d="m 12,2 v 11 h 1 V 2 Z"/>
                <path d="m 14,5 v 5 h 1 V 5 Z"/>
                <path d="m 16,6 v 3 h 1 V 6 Z"/>
                <path d="m 18,4 v 7 h 1 V 4 Z"/>
                <path d="M 2,6 V 9 H 3 V 6 Z"/>
                <path d="m 20,6 v 3 h 1 V 6 Z"/>
                <path d="m 22,7 v 1 h 1 V 7 Z"/>
                <path d="m 15.666667,11 v 4.099333 H 13.1 l 3.3,3.3 3.3,-3.3 H 17.133335 V 11 Z M 12,17.6 c 0,2.427333 1.972667,4.4 4.4,4.4 2.427335,0 4.4,-1.972667 4.4,-4.4 h -1.466665 c 0,1.620666 -1.312668,2.933333 -2.933335,2.933333 -1.620665,0 -2.933333,-1.312667 -2.933333,-2.933333 z"/>
            </g>
        );
    }

}


export default ActiveResourceEvent;